export const SNOWFLAKE_WIDTH_RATIO = 0.85;
